import React from "react";

import { cz } from "../language.json";

export default function Error({ message = cz.general.serverError }) {
  return (
    <h4 className="text-danger app-font-main text-center my-5">{message}</h4>
  );
}
